import { render } from "./TestPage.vue?vue&type=template&id=17485598&scoped=true"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"

import "./TestPage.vue?vue&type=style&index=0&id=17485598&scoped=true&lang=css"

import exportComponent from "/Users/xueke/Develop/Work/rococo/weshow-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17485598"]])

export default __exports__